import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import Stock from '../../types/api/stock'
import MaterialGroup from '../../types/api/material-group'
import getQuery from '../../helpers/api/get-query'

export const stocksApi = createApi({
    reducerPath: 'stocksApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Stocks'],
    endpoints: builder => ({
        getStocks: builder.query<Strapi<Stock>, EndpointQueryParameters | void>({
            query: getQuery('/stocks'),
            providesTags: ['Stocks'],
        }),
        getStockBalances: builder.query<Strapi<MaterialGroup>, void>({
            query: () => '/stocks/balances',
        }),
        createStock: builder.mutation<StrapiSingle<Stock>, StrapiCreate<Stock>>({
            query: body => ({
                url: '/stocks',
                method: 'POST',
                body,
            }),
        }),
        updateStock: builder.mutation<StrapiSingle<Stock>, StrapiUpdate<Stock>>({
            query: body => ({
                url: '/stocks',
                method: 'PUT',
                body,
            }),
        }),
    }),
})

export const { useGetStocksQuery, useGetStockBalancesQuery, useCreateStockMutation, useUpdateStockMutation } =
    stocksApi
